export const fullscreenVODPageTestIDs = {
  fullscreenVODPage: 'fullscreen_vod_player',
};
